<div class="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-gray-900 bg-opacity-50 max-z">
    <div class="animate-spin rounded-full h-20 w-20 border-t-4 border-b-4 border-gray-100"></div>
</div>